import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';

import ModalWithTimer from 'apps/auth/components/utils/ModalWithTimer';
import { AML_LEVEL_BASIC } from 'apps/auth/constants/Constants';
import { AUTH_PROFILE_LIMITS, INCREASE_GT_LIMIT } from 'apps/auth/constants/UrlConstants';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';
import { UsaService } from 'apps/auth/services/UsaService';

import ProvideOccupation from './ProvideOccupation';
import UsaCheckPersonalDetails from './UsaCheckPersonalDetails';
import UsaProvideSsnOrItin from './UsaProvideSsnOrItin';

const UsaProfileAmlStandardLevelInfo = (props) => {
    const { profilePurpleBlock, aml_level_name, personalDetailsBlock, increase_sub_block, notNowButton, nextButton, ssnConfirmed, itinConfirmed } =
        usePageMessages();
    const { userNeedToPassOnfido, profile_form: profile } = useExtra();
    const navigate = useNavigate();

    if (!UsaService.hasProvidedSsnOrItin(profile)) {
        return <UsaProvideSsnOrItin toggleSpinner={props.toggleSpinner} />;
    } else if (UsaService.isUserFromStateWithOccupation(profile) && !UsaService.hasProvidedOccupation(profile)) {
        return <ProvideOccupation />;
    } else if (userNeedToPassOnfido) {
        return <Navigate to={INCREASE_GT_LIMIT} />;
    } else if (
        !UsaService.iDologyCheckSuccessful(profile) ||
        UsaService.isUserFromFlorida(profile) ||
        (UsaService.isUserFromStateWithOccupation(profile) && UsaService.hasProvidedOccupation(profile))
    ) {
        return (
            <UsaCheckPersonalDetails
                currentLevel={AML_LEVEL_BASIC}
                profilePurpleBlock={profilePurpleBlock}
                aml_level_name={aml_level_name}
                personalDetailsBlock={personalDetailsBlock}
                increase_sub_block={increase_sub_block}
                notNowButton={notNowButton}
                nextButton={nextButton}
            />
        );
    } else {
        // user should go to next level:
        return <ModalWithTimer text={UsaService.hasProvidedSsn(profile) ? ssnConfirmed : itinConfirmed} onClick={() => navigate(AUTH_PROFILE_LIMITS)} />;
    }
};

export default UsaProfileAmlStandardLevelInfo;
